import { Easing } from 'react-native-reanimated';

import { LeagueNavigatorItem } from '../components/LeagueNavigator';

export const LEAGUE_ITEM_WIDTH = 44;
export const LEAGUE_ITEM_GAP = 12;
export const LEAGUE_ITEM_LABEL_GAP = 8;
export const LABEL_LINE_HEIGHT = 16;
export const LABEL_SELECTED_WEIGHT = '600';
export const LEAGUE_ITEM_HEIGHT = LEAGUE_ITEM_WIDTH + LEAGUE_ITEM_LABEL_GAP + LABEL_LINE_HEIGHT;

// the distance between two neighbouring items
export const LEAGUE_ITEM_SLOT = LEAGUE_ITEM_WIDTH + LEAGUE_ITEM_GAP;

export const LIST_PADDING_LEFT = 16;
export const LIST_PADDING_RIGHT = 12;
export const LIST_PADDING_TOP = 14;
export const LIST_PADDING_BOTTOM = 16;

export const LIST_GRADIENT_WIDTH = 52;
export const LIST_GRADIENT_HEIGHT = LEAGUE_ITEM_HEIGHT;

export const LEAGUE_NAVIGATOR_HEIGHT = LIST_PADDING_TOP + LEAGUE_ITEM_HEIGHT + LIST_PADDING_BOTTOM;

export const TEXT_GRADIENT_WIDTH = 12;

// scroll distance over which an edge's fade cross-fades from invisible to full strength, and the "view all"
// label reveals/hides at the end edge; shared so both transitions stay in sync with each other
export const EDGE_TRANSITION_DISTANCE = 16;

// the view all button matches a league item's width, plus 6 px of trailing space
export const VIEW_ALL_WIDTH = LEAGUE_ITEM_WIDTH + 6;

// view all is a sibling of the leagues scroll, so centering a selected item in the whole row means
// centering it in the scroll shifted left by half of the view all width
export const CENTER_VIEW_OFFSET = VIEW_ALL_WIDTH / 2;

// two slots left of the first item: fully clipped by the list and outside every label's colour range
export const NO_SELECTION_INDICATOR_OFFSET = -2 * LEAGUE_ITEM_SLOT;

export type LeagueItemLayout = {
    width: number;
    offset: number;
    indicatorOffset: number;
};

export const getLeaguesLayout = (leagues: LeagueNavigatorItem[], labelWidths: Record<string, number>) => {
    let offset = LIST_PADDING_LEFT;

    const layouts = leagues.map(({ id, fitsLabel }): LeagueItemLayout => {
        const width = fitsLabel ? Math.max(LEAGUE_ITEM_WIDTH, Math.ceil(labelWidths[id] ?? 0)) : LEAGUE_ITEM_WIDTH;
        const layout = { width, offset, indicatorOffset: offset + (width - LEAGUE_ITEM_WIDTH) / 2 };

        offset += width + LEAGUE_ITEM_GAP;

        return layout;
    });

    return { layouts, contentWidth: offset - LEAGUE_ITEM_GAP + LIST_PADDING_RIGHT };
};

export const INDICATOR_TIMING = {
    duration: 480,
    easing: Easing.bezier(0.3, 0.85, 0.25, 1.07),
};

export const SPECIAL_TABS: Record<'explore' | 'promos' | 'live', Pick<LeagueNavigatorItem, 'image' | 'fitsLabel'>> = {
    explore: { image: require('@/assets/images/league-nav/explore.png'), fitsLabel: true },
    promos: { image: require('@/assets/images/league-nav/promos.png'), fitsLabel: true },
    live: { image: require('@/assets/images/league-nav/live.png') },
};

export const COMMON_LEAGUE_ITEMS: LeagueNavigatorItem[] = [
    { id: 'explore', label: 'Explore', ...SPECIAL_TABS.explore },
    { id: 'promos', label: 'Promos', ...SPECIAL_TABS.promos },
    { id: 'live', label: 'Live', ...SPECIAL_TABS.live },
];

export const MOCK_LEAGUES: LeagueNavigatorItem[] = [
    ...COMMON_LEAGUE_ITEMS,
    { id: 'nba', label: 'NBA', image: require('@/assets/images/league-nav/nba.png') },
    { id: 'nfl', label: 'NFL', image: require('@/assets/images/league-nav/nfl.png') },
    { id: 'wimbledon', label: 'Wimbledon', image: require('@/assets/images/league-nav/wimbledon.png') },
    { id: 'masters', label: 'Masters', image: require('@/assets/images/league-nav/masters.png') },
    { id: 'cfb', label: 'CFB', image: require('@/assets/images/league-nav/cfb.png') },
    { id: 'epl', label: 'EPL', image: require('@/assets/images/league-nav/epl.png') },
    { id: 'bun', label: 'BUN', image: require('@/assets/images/league-nav/bun.png') },
    { id: 'soccer', label: 'Soccer', image: require('@/assets/images/league-nav/soccer.png') },
    { id: 'tennis', label: 'Tennis', image: require('@/assets/images/league-nav/tennis.png') },
    { id: 'basketball', label: 'Basketball', image: require('@/assets/images/league-nav/basketball.png') },
    { id: 'golf', label: 'Golf', image: require('@/assets/images/league-nav/golf.png') },
    { id: 'hockey', label: 'Hockey', image: require('@/assets/images/league-nav/hockey.png') },
];
